import * as s from "../VideoShareStyled";
import { FaShareFromSquare } from "react-icons/fa6";
import { COLORS } from "styles/colors";
import { VideoShareResult } from "api/interfaces/videoshareInterface.interface";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import AddVS from "../view/add";
import {
  checkTimezone,
  convertVideoStartMs,
  getAccountTimeFormat,
} from "utils/timeUtil";
import { checkEmpty, isNumber, matchHashTag } from "utils/functions";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import VideoShareThumbnail from "components/atoms/image/thumbnail/VideoShareThumbnail";
import RecorderTitle from "components/blocks/recorder/RecorderTitle";
import { useAppSelector } from "redux/hooks";
import * as mediaQuery from "components/MediaQuery";
import ModalTemplate from "components/templates/modal/ModalTemplate";
import { useMenu } from "hook/useMenu";

type Props = {
  index: number;
  item: VideoShareResult;
  onModelVisible: boolean;
  onClickShare: (videoId: string, isOpen: boolean) => void;
  selectedTag: string[];
  selectedAccount: ProfileAccountInfo;
};

export default function VideoSharePoster({
  item,
  index,
  onModelVisible,
  onClickShare,
  selectedTag,
  selectedAccount,
}: Props): JSX.Element {
  const themeMode = useAppSelector((state) => state.theme.theme);
  const buttonRef = useRef<any>(null);
  const shareRef = useRef<any>(null);
  const [isShare, setIsShare] = useState<boolean>(false);
  const [isHoveredThumbnail, setIsHoveredThumbnail] = useState<boolean>(false);
  const { menuNavigation } = useMenu({});

  const containerRef = useRef<HTMLUListElement>(null);
  const [hiddenItemsCount, setHiddenItemsCount] = useState(0);

  const onViewDetail = (item: any, e: any) => {
    menuNavigation({ to: `/videoShare/${item.videoId}` });
  };

  useEffect(() => {
    setIsShare(item.sharing);
  }, [item.sharing]);

  useEffect(() => {
    const onClick = (event: any) => {
      console.log(event);
      if (
        (buttonRef.current && !buttonRef.current.contains(event.target)) ||
        (shareRef.current && !shareRef.current.contains(event.target))
      ) {
        console.log("-----");
        onModal(item.videoId, false);
      }
    };

    window.addEventListener("click", onClick);

    return function cleanup() {
      window.removeEventListener("click", onClick);
      onModal(item.videoId, false);
    };
  }, [buttonRef, shareRef]);

  useEffect(() => {
    setIsShare(onModelVisible);
  }, [onModelVisible]);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setHiddenItemsCount(countAndHideHiddenItems(containerRef.current));
      }
    };

    window.addEventListener("resize", handleResize);

    // Initial count on mount
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window, item]);

  const countAndHideHiddenItems = (container: HTMLUListElement): number => {
    const containerRect = container.getBoundingClientRect();
    const items = Array.from(container.children) as HTMLUListElement[];
    let hiddenCount = 0;

    items.forEach((item) => {
      const itemRect = item.getBoundingClientRect();
      const isHidden =
        itemRect.right > containerRect.right ||
        itemRect.bottom > containerRect.bottom ||
        itemRect.left < containerRect.left ||
        itemRect.top < containerRect.top;

      if (isHidden) {
        item.style.visibility = "hidden";
        hiddenCount++;
      } else {
        item.style.visibility = "visible";
      }
    });

    return hiddenCount;
  };

  const onModal = (videoId: string, on?: boolean) => {
    setIsShare(on !== undefined ? on : !isShare);
    onClickShare(videoId, on !== undefined ? on : !isShare);
  };

  const onHoverThumbnail = (isHover: boolean) => {
    setIsHoveredThumbnail(isHover);
  };

  useEffect(() => {
    //item 변경되면 강제 렌더링
  }, [item]);
  const getTimezone = () => {
    const serverTimezone = checkTimezone(item.displayTimeZone ?? item.timezone);
    if (serverTimezone === "") {
      return selectedAccount.timezone;
    }
    return serverTimezone;
  };
  return (
    <>
      <s.VideoItem key={`video-share-poster-${item.videoId}-${index}`}>
        <s.VideoImage
          uploadStatus={item.uploadStatus}
          onClick={(e) => {
            onViewDetail(item, e);
          }}
          data-testid="videoshare-list-list-video-image-view-detail"
        >
          {!isHoveredThumbnail && (
            <>
              <s.ImageLabel>{item.cameraName}</s.ImageLabel>
              <s.ImageLabel time>
                {item.startTimeMs !== undefined
                  ? isNumber(item.startTimeMs)
                    ? Number(item.startTimeMs) === 0
                      ? ""
                      : convertVideoStartMs(
                          item.startTimeMs,
                          getTimezone(),
                          selectedAccount
                        )
                    : getAccountTimeFormat(
                        item.startTimeMs,
                        {
                          ...selectedAccount,
                          timezone: getTimezone(),
                        },
                        true
                      )
                  : "--:--"}
              </s.ImageLabel>
            </>
          )}

          <VideoShareThumbnail
            videoUrl={item.url}
            thumbnailUrl={item.thumbnailUrl}
            uploadStatus={item.uploadStatus}
            status={item.status}
            isShare={item.sharing}
            isHoveredThumbnail={isHoveredThumbnail}
            onHoverThumbnail={onHoverThumbnail}
            index={index}
          />
        </s.VideoImage>
        <s.VideoSection>
          <s.VideoTitle title={item.title}>
            <div className="video-title-inner">
              {item.title ? item.title : "Undefined"}
            </div>
            {/* <Text className="time" fontSize={14} bold color={`${COLORS.WHITE}50`}> */}
            {/* {item.timestamp} */}
            {/* {changeTimeStampFormat(item.timestamp, item.timezone)} */}
            {/* </Text> */}
            <RecorderTitle
              mergedSystemName={item.mergedSystemName}
              recorderName={item.recorderName}
              type={item.type}
            />
          </s.VideoTitle>
          {/* uploadStatus가 success가 아닌경우 공유버튼 X */}
          {item.uploadStatus === "success" && selectedAccount.isEnabled && (
            <s.ShareWrapper>
              <button
                ref={buttonRef}
                onClick={(e) => {
                  e.stopPropagation();
                  onModal(item.videoId);
                }}
                data-testid={`videoshare-list-list-button-share-${index}`}
              >
                <FaShareFromSquare
                  color={
                    onModelVisible
                      ? themeMode === "light"
                        ? COLORS.COMPANY
                        : COLORS.SELECTED
                      : themeMode === "light"
                      ? COLORS.BLACK
                      : COLORS.WHITE
                  }
                />

                {/* <img
                className="share-img"
                src={onModelVisible ? SHARE_BLUE_ICON : SHARE_ICON}
                alt="share_popup_visible"
                /> */}
              </button>
              <mediaQuery.Default>
                {onModelVisible && (
                  <div
                    onClick={(e) => {
                      // console.log("??");
                      e.stopPropagation();
                    }}
                  >
                    <AddVS
                      small
                      ref={shareRef}
                      index={index}
                      videoId={item.videoId}
                      isShare={item.sharing}
                      onChangeModal={() => {
                        onModal(item.videoId, false);

                        return;
                      }}
                    />
                  </div>
                )}
              </mediaQuery.Default>
            </s.ShareWrapper>
          )}
        </s.VideoSection>
        <s.TagBox>
          <s.FilterWrapper className="container" ref={containerRef}>
            {item.tags
              ?.sort((a, b) => {
                return selectedTag.includes(a.tag) ? -1 : 1;
              })
              .map((tag, idx) =>
                // console.log(tag.tag),
                tag.tag !== undefined && !checkEmpty(tag.tag) ? (
                  <s.Hashtag
                    key={idx}
                    isFilter={matchHashTag(selectedTag, tag.tag)}
                  >
                    {`#${tag.tag}`}
                  </s.Hashtag>
                ) : (
                  <Fragment />
                )
              )}
          </s.FilterWrapper>
          <span className="hidden-count">
            {hiddenItemsCount > 0 && `+ ${hiddenItemsCount}`}
          </span>
        </s.TagBox>
      </s.VideoItem>
      <mediaQuery.Mobile>
        {onModelVisible && (
          <ModalTemplate center>
            <s.MobileModalInner>
              <AddVS
                small
                ref={shareRef}
                index={index}
                videoId={item.videoId}
                isShare={item.sharing}
                onChangeModal={() => {
                  onModal(item.videoId, false);
                  return;
                }}
              />
            </s.MobileModalInner>
          </ModalTemplate>
        )}
      </mediaQuery.Mobile>
    </>
  );
}
